module.exports = __webpack_public_path__ + "img/eggs-game.36dc6728.webp";